import images from "assets/images/images";
import SwitchToggle from "components/form-elements/switchToggle/SwitchToggle";
import React, { useRef, useState } from "react";


const SimpleAccordion = ({border, switchOpen, header, content, onCheckboxChange, checkboxName}) => {
  const [active, setActive] = useState(false);
  const contentRef = useRef(null);
  const [height, setHeight] = useState("0px");


  function toggleAccordion() {
    setActive(!active);
    setHeight(active ? "0px" : `${contentRef.current.scrollHeight}px`);
  }


  return (
    <div style={border ? {border: ' 1px solid #DBDBDB'} : {}} className={`card card-accordion ${active ? "active" : ""}`}>
      <div
        className='card-accordion-header'
        onClick={toggleAccordion}
      >
        {header}
        <div className="d-flex align-items-center gap-1">
          {switchOpen && <SwitchToggle name={checkboxName} onChange={onCheckboxChange}/>}
          <img className="card-accordion-header-icon" src={images.chevronDown} alt="" />
        </div>
      </div>
      <div
        ref={contentRef}
        style={{ maxHeight: `${height}` }}
        className="card-accordion-content"
      >
        {content}
      </div>
    </div>
  );
}

export default SimpleAccordion;
